// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visually-hidden {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
@keyframes list-fill {
  0% {
    opacity: 0;
    transform: translateX(30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes reverse-list-fill {
  0% {
    opacity: 0;
    transform: translateX(-30%);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
app-root .styles-page ul.styles {
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}
app-root .styles-page ul.styles li {
  will-change: transform, opacity;
  animation: 0.3s ease-in-out normal backwards list-fill;
}
app-root .styles-page ul.styles li:nth-of-type(1) {
  animation-delay: 0s;
}
app-root .styles-page ul.styles li:nth-of-type(2) {
  animation-delay: 0.06s;
}
app-root .styles-page ul.styles li:nth-of-type(3) {
  animation-delay: 0.12s;
}
app-root .styles-page ul.styles li:nth-of-type(4) {
  animation-delay: 0.18s;
}
app-root .styles-page ul.styles li:nth-of-type(5) {
  animation-delay: 0.24s;
}
app-root .styles-page ul.styles li:nth-of-type(6) {
  animation-delay: 0.3s;
}
app-root .styles-page ul.styles li:nth-of-type(7) {
  animation-delay: 0.36s;
}
app-root .styles-page ul.styles li:nth-of-type(8) {
  animation-delay: 0.42s;
}
app-root .styles-page ul.styles li:nth-of-type(9) {
  animation-delay: 0.48s;
}
app-root .styles-page ul.styles li:nth-of-type(10) {
  animation-delay: 0.54s;
}
app-root .styles-page ul.styles li:nth-of-type(11) {
  animation-delay: 0.6s;
}
app-root .styles-page ul.styles li:nth-of-type(12) {
  animation-delay: 0.66s;
}
app-root .styles-page ul.styles li:nth-of-type(13) {
  animation-delay: 0.72s;
}
app-root .styles-page ul.styles li:nth-of-type(14) {
  animation-delay: 0.78s;
}
app-root .styles-page ul.styles li:nth-of-type(15) {
  animation-delay: 0.84s;
}
@media (max-width: 599px) {
  app-root .styles-page ul.styles {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }
  app-root .styles-page ul.styles li {
    display: flex;
  }
  app-root .styles-page ul.styles li > .radio-button,
  app-root .styles-page ul.styles li > .checkbox-button {
    display: flex;
    flex: 1;
    min-width: 0;
  }
  app-root .styles-page ul.styles li label {
    display: flex;
    align-items: center;
    flex: 1;
    text-align: left;
  }
}
app-root .styles-page.reverse-transitions ul.styles li {
  animation-name: reverse-list-fill;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/utilities.less","webpack://./src/Views/FormSteps/Styles/StylesInput.less","webpack://./src/Styles/buttonList.less"],"names":[],"mappings":"AA6BA;EAnBE,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;ACRF;AC0CA;EACE;IACE,UAAA;IACA,0BAAA;EDxCF;EC2CA;IACE,UAAA;IACA,wBAAA;EDzCF;AACF;AC4CA;EACE;IACE,UAAA;IACA,2BAAA;ED1CF;EC6CA;IACE,UAAA;IACA,wBAAA;ED3CF;AACF;AA1BA;ECGM,aAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;AD0BN;AAlCA;ECWQ,+BAAA;EACA,sDAAA;AD0BR;ADqDG;EACC,mBAAA;ACnDJ;ADkDG;EACC,sBAAA;AChDJ;AD+CG;EACC,sBAAA;AC7CJ;AD4CG;EACC,sBAAA;AC1CJ;ADyCG;EACC,sBAAA;ACvCJ;ADsCG;EACC,qBAAA;ACpCJ;ADmCG;EACC,sBAAA;ACjCJ;ADgCG;EACC,sBAAA;AC9BJ;AD6BG;EACC,sBAAA;AC3BJ;AD0BG;EACC,sBAAA;ACxBJ;ADuBG;EACC,qBAAA;ACrBJ;ADoBG;EACC,sBAAA;AClBJ;ADiBG;EACC,sBAAA;ACfJ;ADcG;EACC,sBAAA;ACZJ;ADWG;EACC,sBAAA;ACTJ;AClEM;EAAA;IACE,aAAA;IACA,qCAAA;IACA,SAAA;EDqEN;ECxEI;IAMI,aAAA;EDqER;EC3EI;;IAUM,aAAA;IACA,OAAA;IACA,YAAA;EDqEV;ECjFI;IAgBM,aAAA;IACA,mBAAA;IACA,OAAA;IACA,gBAAA;EDoEV;AACF;AC/DK;EACC,iCAAA;ADiEN","sourcesContent":["@import './mediaQueries.less';\n@import './GridLayout/layoutHelpers.less';\n\n@pseudo-header-height: 64px;\n@progress-bar-height: 0.25rem;\n@body-gutter-width: 16px;\n@nav-height: calc(1.5rem + 47px);\n\n// styles for screen-reader only content\n.visually-hidden-content() {\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n\n.unset-visually-hidden-content() {\n  clip: unset;\n  clip-path: unset;\n  height: unset;\n  overflow: unset;\n  position: unset;\n  white-space: unset;\n  width: unset;\n}\n\n.visually-hidden {\n  .visually-hidden-content();\n}\n\n.fixed-full-width-content() {\n  margin: 0 -16px;\n  left: 16px;\n  width: 100%;\n  min-width: 320px;\n  position: fixed;\n}\n\n.wide-content() {\n  .main-content-width-rules(6);\n}\n.narrow-content() {\n  .main-content-width-rules(4);\n}\n\n// LF Overrides - the 'wide' content covers 2/3 of full width on large screens\n\n.wide-leadfeed-content() {\n  .wide-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8);\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(8, 10);\n  }\n  @media @largeDesktopUp {\n    .calc-column-width(6, 10);\n  }\n}\n.narrow-leadfeed-content() {\n  .narrow-content();\n  @media @desktopUp {\n    .calc-column-width(6, 8) // same as wide content;\n  }\n  @media @mediumDesktopUp {\n    .calc-column-width(4, 10);\n  }\n}\n\n.fixed-two-third-width-content() {\n  .fixed-full-width-content();\n  @media @desktopUp {\n    width: 66%;\n  }\n}\n\n// For use within a 'wide' content container\n.nested-input() {\n  .nested-input-width-rules(6);\n}\n\n// For use within a 'wide' content container\n.nested-lf-input() {\n  .nested-input-width-rules(6,8);\n}\n\n// For delaying repeated animation on a list or group of matching elements\n.sequential-delay(@counter, @delay, @child-selector: ~'', @base-delay: 0) when (@counter > 0) {\n  .sequential-delay((@counter - 1), @delay, @child-selector, @base-delay); // next iteration\n\n  &:nth-of-type(@{counter})@{child-selector} {\n    animation-delay: (@base-delay + @delay * (@counter - 1)); // code for each iteration\n  }\n}\n","@import '../../../Styles/buttonList.less';\n\napp-root {\n  .button-list-styles(styles-page, styles);\n}\n","@import './utilities.less';\n\n.button-list-styles(@page-class, @list-class, @base-delay: 0 ) {\n  .@{page-class} {\n    ul.@{list-class} {\n      display: flex;\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-wrap: wrap;\n      justify-content: center;\n      gap: 16px;\n\n      li {\n        will-change: transform, opacity;\n        animation: 0.3s ease-in-out normal backwards list-fill;\n        .sequential-delay(15, 0.06s, ~'', @base-delay);\n      }\n\n      // Phones: one full-width list instead of centred rows of mixed widths\n      @media @mobile {\n        display: grid;\n        grid-template-columns: minmax(0, 1fr);\n        gap: 10px;\n\n        li {\n          display: flex;\n\n          > .radio-button,\n          > .checkbox-button {\n            display: flex;\n            flex: 1;\n            min-width: 0;\n          }\n\n          label {\n            display: flex;\n            align-items: center;\n            flex: 1;\n            text-align: left;\n          }\n        }\n      }\n    }\n\n    &.reverse-transitions ul.@{list-class} li {\n      animation-name: reverse-list-fill;\n    }\n  }\n}\n\n@keyframes list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n\n@keyframes reverse-list-fill {\n  0% {\n    opacity: 0;\n    transform: translateX((-30%));\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX((0));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
